import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const dusk = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#FFFFFF',
    pageBackground: '#374835',
    secondaryFont: '#F2FF8A',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.paris.dusk.accent
      ? THEME_DEFAULT_FONTS.paris.dusk.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.paris.dusk.body.value,
    heading: THEME_DEFAULT_FONTS.paris.dusk.headline.value,
  },
  fontWeights: {
    body: 400,
    heading: 500,
  },
  shadows: {
    basic10: '0 0 $64 rgba(228, 232, 247, 0.15)',
  },
});
